import { createReducer, on } from '@ngrx/store';
import { setSiteId, setStudyId } from '../actions/siteWorkspace.action';


interface SiteWorkSpaceState {
  study_id: string;
  site_id: string;
}

export const initialState: SiteWorkSpaceState = {
  study_id: '',
  site_id: '',
};
export const siteWorkspaceReducer = createReducer(
  initialState,
  on(setStudyId, (state, { study_id }) => ({
    ...state,
    study_id: study_id,
  })),
  on(setSiteId, (state, { site_id }) => ({
    ...state,
    site_id: site_id,
  })),
);
